import {connect} from 'react-redux';
import {push} from 'connected-react-router'
import {
    Header, 
    Button,
    ErrorMark
} from '../../components/RegularComponents'
import CheckboxForm from '../../components/CheckBoxForm'
import TopNavigationBar from "../TopNavigationBar"
import { useState } from 'react';
import {replaceUrlParams} from '../../app/utils'
import {collectorBeforeStartConfirmationSelect} from '../../redux/selector/collectorBeforeStartConfirmationSelector'
import Navigation from '../Navigation';
import {
    VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT
} from '../../app/constants'
import { ERROR_STRING } from '../../app/errors';
import { addNewAgentApplication } from '../../redux/slice/additionalApplicationsSlice';

const CollectorBeforeStartConfirmation = (props) => {

    const { applicationType, applicationMode } = props.match.params
    const { viewMode } = props
    const { 
        businessContactName,
        primaryApplicationLicencingSubType, 
        businessApplicationId, 
        businessName,
        companyRjscDetails,
        companyTrademark 
    } = props.collectorBeforeStartConfirmation

    const collectorBeforeStartConfirmation = props.collectorBeforeStartConfirmation[applicationType] ? 
                    props.collectorBeforeStartConfirmation[applicationType] : 
                        props.collectorBeforeStartConfirmation
    const [ageConfirmationSelection, SetAgeConfirmationSelection] = useState(false)
    const [businessContactEligibleConfirmationSelection, SetBusinessContactEligibleConfirmationSelection] = useState(false)
    const [showValidateionError, setShowValidationError] = useState(false)

    const businessContactEligibleConfirmationLabelText = `Confirm that I, ${businessContactName ?? "business contact"}, have the authority to license this individual on behalf of the agency.`
    return (
        <>
            {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
            <Navigation {...props} /> }
            <div className={viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT ? "container" : ""}>
            <TopNavigationBar {...props} />
            <div className="row bottomMarginMedium">
                <div className="col-lg-8">
                    <Header header={collectorBeforeStartConfirmation.header} />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-8">
                    Make sure you have:
                </div>
            </div>
            <div className="row">
                <div className="col-lg-8">
                    <ul>
                        <li>
                            The applicant's full name, civic address, and phone number
                        </li>
                    </ul>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-8">
                    You will need to provide details if the applicant has:
                </div>
            </div>
            <div className="row">
                <div className="col-lg-8">
                    <ul>
                        <li>
                            been convicted of an offence and have not been pardoned
                        </li>
                        <li>
                            had a licence refused, suspended or revoked
                        </li>
                    </ul>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-8"> 
                    <CheckboxForm 
                        id="collector-age-confirmation-checkbox"
                        checked={ageConfirmationSelection}
                        value={ageConfirmationSelection}
                        labelText="Confirm the applicant is at least 19 years old"
                        onCheckBoxChange={(val) => {
                            if(val && businessContactEligibleConfirmationSelection) {
                                setShowValidationError(false)
                            }
                            SetAgeConfirmationSelection(val)
                        }}
                        />
                </div>
            </div>

            <div className="row">
                <div className="col-lg-8"> 
                    <CheckboxForm 
                        id="business-contact-eligible-confirmation-checkbox"
                        checked={businessContactEligibleConfirmationSelection}
                        value={businessContactEligibleConfirmationSelection}
                        labelText={businessContactEligibleConfirmationLabelText}
                        onCheckBoxChange={(val) => {
                            if(val && ageConfirmationSelection) {
                                setShowValidationError(false)
                            }
                            SetBusinessContactEligibleConfirmationSelection(val)
                        }}
                    />
                </div>
            </div>

            <div className="row">
                <div className={"col-lg-4" + (showValidateionError ? " has-error" : "")}>
                    <Button
                        id="collection-before-start-confirmaiton-continue-button"
                        buttonType={"regular_primary"}
                        text={"Continue"}
                        onClick={() => {

                            if(!ageConfirmationSelection || 
                                !businessContactEligibleConfirmationSelection) { 
                                    setShowValidationError(true)
                                    return
                                }

                            setShowValidationError(false)

                            props.dispatch(addNewAgentApplication({
                                primaryApplicationLicencingSubType,
                                businessApplicationId,
                                businessName,
                                companyRjscDetails,
                                companyTrademark : companyTrademark ? companyTrademark : null
                            }))
                            
                            props.dispatch(push(replaceUrlParams(collectorBeforeStartConfirmation.navigation.next,applicationType, applicationMode)))
                        }}
                    />
                    {showValidateionError && ErrorMark()}
                    {showValidateionError && <div className="help-block">
                        {ERROR_STRING.AGENT_DETAILS_ENTRY_CONFIRMATION_CHECK_BOXES_NOT_CLICKED}
                    </div>}
                </div>
            </div>
        </div>
        </>
    )
}

export default connect(collectorBeforeStartConfirmationSelect)(CollectorBeforeStartConfirmation)